/* sst-about-story.js — About Story image carousel (arrows + drag/swipe + dots) */
(function () {
  function init(root) {
    var stage = root.querySelector('[data-as-stage]');
    var track = root.querySelector('[data-as-track]');
    if (!stage || !track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-as-dot]'));
    if (slides.length < 2) return;
    var current = 0;

    function goTo(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + -current * 100 + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === current); });
    }

    var prev = root.querySelector('[data-as-prev]');
    var next = root.querySelector('[data-as-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10) || 0); });
    });

    /* Drag / swipe */
    var dragging = false, startX = 0, deltaX = 0;
    function down(x) { dragging = true; startX = x; deltaX = 0; track.style.transition = 'none'; stage.classList.add('is-dragging'); }
    function move(x) {
      if (!dragging) return;
      deltaX = x - startX;
      var pct = (deltaX / stage.offsetWidth) * 100;
      track.style.transform = 'translateX(' + (-current * 100 + pct) + '%)';
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      stage.classList.remove('is-dragging');
      var threshold = stage.offsetWidth * 0.15;
      if (deltaX > threshold) goTo(current - 1);
      else if (deltaX < -threshold) goTo(current + 1);
      else goTo(current);
    }

    stage.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function (e) { move(e.clientX); });
    window.addEventListener('mouseup', up);
    stage.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    stage.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    stage.addEventListener('touchend', up);
  }

  document.querySelectorAll('[data-as-carousel]').forEach(init);
})();
